import { render, staticRenderFns } from "./AddPerson2.vue?vue&type=template&id=ba797bc4&scoped=true&"
import script from "./AddPerson2.vue?vue&type=script&lang=js&"
export * from "./AddPerson2.vue?vue&type=script&lang=js&"
import style0 from "./AddPerson2.vue?vue&type=style&index=0&id=ba797bc4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba797bc4",
  null
  
)

export default component.exports